export default __webpack_public_path__ + "static/media/kinkakuji.8f816fe3.jpeg";